import { z } from 'zod';

/** Password rules aligned with BE Identity defaults: min 8, uppercase, lowercase, digit, non-alphanumeric. */
export const passwordSchema = z
  .string()
  .min(8, 'Almeno 8 caratteri')
  .regex(/[a-z]/, 'Almeno una lettera minuscola')
  .regex(/[A-Z]/, 'Almeno una lettera maiuscola')
  .regex(/\d/, 'Almeno una cifra')
  .regex(/[^A-Za-z0-9]/, 'Almeno un carattere speciale');

export interface PasswordStrength {
  score: 0 | 1 | 2 | 3 | 4;
  label: 'Molto debole' | 'Debole' | 'Discreta' | 'Buona' | 'Ottima';
  color: 'red' | 'orange' | 'yellow' | 'lime' | 'green';
}

export function computeStrength(pwd: string): PasswordStrength {
  let score = 0;
  if (pwd.length >= 8) score++;
  if (/[A-Z]/.test(pwd) && /[a-z]/.test(pwd)) score++;
  if (/\d/.test(pwd)) score++;
  if (/[^A-Za-z0-9]/.test(pwd)) score++;
  if (pwd.length >= 14) score = Math.min(4, score + 1);
  const map: Record<number, PasswordStrength> = {
    0: { score: 0, label: 'Molto debole', color: 'red' },
    1: { score: 1, label: 'Debole', color: 'orange' },
    2: { score: 2, label: 'Discreta', color: 'yellow' },
    3: { score: 3, label: 'Buona', color: 'lime' },
    4: { score: 4, label: 'Ottima', color: 'green' },
  };
  return map[score as 0 | 1 | 2 | 3 | 4];
}
